import PrimaryHeader from './PrimaryHeader';

export default PrimaryHeader;
